import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import env from '@/lib/env'
import store from '@/lib/store'
import router from '@/plugins/router'

Vue.use(VueAnalytics, {
  id: env('GOOGLE_ANALYTICS_ID'),
  router,
  debug: {
    enabled: false,
    trace: false,
    sendHitTask: false
  },
  onReady () {
    const user = store.get('user')
    if (user) {
      Vue.$ga.set('userId', user.id)
    }
  }
})



// WEBPACK FOOTER //
// ./src/plugins/ga.js